import { getAccidental } from "../../../../common/parameters";
import { IDoPos, IParsedDo, IScoreEditorThis } from "../../../../common/types";

export function changeDo(this: IScoreEditorThis, _do: IParsedDo) {
    const i = getAccidental({ _do });
    let o: IDoPos["o"] = 1;
    if (_do.value < -13) o = 2;
    else if (_do.value < -6) o = 3;
    else if (_do.value < 1) o = 4;
    else if (_do.value < 8) o = 5;
    const score = { ...this.state.score };
    score.doPos = { i, o };
    this.setState({ score });
}

export const parseDo = (doPos: IDoPos): IParsedDo => {
    let value = (((doPos.i < 0 ? doPos.i + 14 : doPos.i) * 4) % 7) - 6;
    value += (doPos.o - 4) * 7;
    let alt = 0;
    if (doPos.i < -1) alt = -1;
    if (doPos.i > 5) alt = 1;
    return {
        value,
        alt,
    };
};

export const handleChangeOctave = function (this: IScoreEditorThis, octave: number, n: number) {
    const score = { ...this.state.score };
    score["octave" + n] = octave;
    this.setState({ score });
};
